<template>
  <div class="experience">
    <div class="mode">
      <div class="info">
        <vs-card>
          <template #title>
            <h3>{{ info.duration }}</h3>
          </template>
          <template #img>
            <img :src="require(`@/assets/images/${info.image}`)" alt="Logo" />
          </template>
          <template #text>
            <p>
              {{ info.job }}
            </p>
          </template>
        </vs-card>
      </div>
      <div class="detail">
        <div class="company">
          {{ detail.company }}
        </div>
        <ul class="tasks">
          <li class="task" v-for="(task, index) in detail.tasks" :key="index">
            <p>
              {{ task }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      required: true
    },
    detail: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.experience {
  width: 100%;
  height: auto;
  padding: 1em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mode {
  width: 80%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

.info {
  padding: 1em;
  width: 270px;
}

.detail {
  padding: 1em;
  flex: 1;
}

.company {
  font-size: 1.5em;
  font-family: "Comfortaa", cursive, Arial, Helvetica, sans-serif;
}

.right .company {
  text-align: right;
}

.company::before {
  content: "";
  position: absolute;
  width: 40px;
  height: 3px;
  background: #029aff;
  transform: translateY(-200%);
}
</style>

<style scoped>
@media screen and (max-width: 1050px) {
  .mode {
    width: 90%;
  }
}
</style>

<style scoped>
@media screen and (max-width: 900px) {
  .mode {
    width: 100%;
  }
}
</style>

<style scoped>
@media screen and (max-width: 750px) {
  .mode {
    flex-direction: column;
    align-items: center;
    width: 95%;
  }
}
</style>
